import React, { useContext } from "react";
import { LanguageContext, text } from "../../../container/language";

const Paragraph = ({ data, className = "" }) => {
  const { userLanguage } = useContext(LanguageContext);
  const html = text(data, userLanguage);

  return (
    <>
      <p>
        <p
          className={className}
          style={{ verticalAlign: "inherit", lineHeight: 1.571 }}
          dangerouslySetInnerHTML={{ __html: html }}
        ></p>
      </p>
    </>
  );
};

export default Paragraph;
